var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_money-send",
    "data-name": "vuesax/bulk/money-send",
    transform: "translate(-428 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "money-send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(428 444)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M15,5.75a.742.742,0,0,1-.53-.22.754.754,0,0,1,0-1.06l2.05-2.05a10,10,0,1,0,1.06,1.06L15.53,5.53A.742.742,0,0,1,15,5.75Z",
    transform: "translate(430 446)",
    fill: "#908fa2",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5,5.07,4,4.72V2.5h.08A.963.963,0,0,1,5,3.5a.75.75,0,0,0,1.5,0A2.459,2.459,0,0,0,4.08,1H4V.75a.75.75,0,0,0-1.5,0V1H2.2A2.244,2.244,0,0,0,0,3.28,2.05,2.05,0,0,0,1.5,5.44l1,.35V8.01H2.42a.963.963,0,0,1-.92-1,.755.755,0,0,0-.75-.75A.755.755,0,0,0,0,7.01a2.459,2.459,0,0,0,2.42,2.5H2.5v.25a.75.75,0,0,0,1.5,0V9.51h.3A2.244,2.244,0,0,0,6.5,7.23,2.033,2.033,0,0,0,5,5.07ZM1.99,4.01c-.34-.12-.49-.19-.49-.74a.748.748,0,0,1,.7-.78h.3V4.18ZM4.3,8H4V6.31l.51.18c.34.12.49.19.49.74A.745.745,0,0,1,4.3,8Z",
    transform: "translate(436.75 450.75)",
    fill: "#908fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M5.45.47A.782.782,0,0,0,5.04.06.717.717,0,0,0,4.75,0h-4A.755.755,0,0,0,0,.75a.755.755,0,0,0,.75.75H2.94L1.27,3.17A10.607,10.607,0,0,1,2.33,4.23L4,2.56v2.2a.75.75,0,0,0,1.5,0v-4A.6.6,0,0,0,5.45.47Z",
    transform: "translate(445.24 445.24)",
    fill: "#908fa2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.f81f7123bbde7e3cc09310dc2bfe2e09.svg";
export { ForwardRef as ReactComponent };